<template>
  <div class="date-range-picker-wrap">
    <span class="date-range-label" v-if="label">{{ label }}</span>
    <span
      class="pulic_operatArea_now pulic_cursor"
      :class="dateNowDayActive ? 'public_dateActive' : ''"
      @click="setNowDay"
    >当日</span>
    <span
      class="public_operatArea_yesterday pulic_cursor"
      :class="dateYesterdayActive ? 'public_dateActive' : ''"
      @click="setYesterday"
    >昨天</span>
    <span
      class="pulic_operatArea_now pulic_cursor"
      :class="dateNowMonthActive ? 'public_dateActive' : ''"
      @click="setSameMonth"
    >当月</span>
    <span
      class="public_operatArea_yesterday pulic_cursor"
      :class="dateLastMonthActive ? 'public_dateActive' : ''"
      @click="setLastMonth"
    >上月</span>
    <div class="public_operatArea_timePicker pulic_cursor">
      <el-date-picker
        v-model="innerDate"
        value-format="yyyy-MM-dd HH:mm:ss"
        type="datetimerange"
        range-separator="至"
        :picker-options="startDateDisabled"
        start-placeholder="开始日"
        end-placeholder="结束日"
        class="pulic_cursor"
        @change="onPickerChange"
      ></el-date-picker>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DateRangePicker',
  props: {
    // 父组件用 v-model 绑定，值为 [startTime, endTime] 字符串数组
    value: {
      type: Array,
      default: () => []
    },
    // 左侧标签文字，不传则不显示
    label: {
      type: String,
      default: ''
    },
    // 默认快捷方式：nowDay / yesterday / sameMonth / lastMonth
    defaultShortcut: {
      type: String,
      default: 'nowDay'
    }
  },
  data() {
    return {
      innerDate: [],
      dateNowDayActive: false,
      dateYesterdayActive: false,
      dateNowMonthActive: false,
      dateLastMonthActive: false,
      startDateDisabled: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      }
    }
  },
  created() {
    if (this.value && this.value.length === 2) {
      this.innerDate = [...this.value]
    } else {
      this.applyShortcut(this.defaultShortcut)
    }
  },
  watch: {
    value(val) {
      if (val && val.length === 2) {
        this.innerDate = [...val]
      }
    }
  },
  methods: {
    fmt(date) {
      const d = date instanceof Date ? date : new Date(date)
      const pad = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
    },

    applyShortcut(type) {
      const map = {
        nowDay: this.setNowDay,
        yesterday: this.setYesterday,
        sameMonth: this.setSameMonth,
        lastMonth: this.setLastMonth,
      }
      if (map[type]) map[type]()
    },

    clearActive() {
      this.dateNowDayActive = false
      this.dateYesterdayActive = false
      this.dateNowMonthActive = false
      this.dateLastMonthActive = false
    },

    emit(range) {
      this.innerDate = range
      this.$emit('input', range)
      this.$emit('change', range)
    },

    setNowDay() {
      const today = this.fmt(new Date())
      this.emit([today + ' 00:00:00', today + ' 23:59:59'])
      this.clearActive()
      this.dateNowDayActive = true
    },

    setYesterday() {
      const d = new Date(new Date().getTime() - 86400000)
      const day = this.fmt(d)
      this.emit([day + ' 00:00:00', day + ' 23:59:59'])
      this.clearActive()
      this.dateYesterdayActive = true
    },

    setSameMonth() {
      const now = new Date()
      const first = this.fmt(new Date(now.getFullYear(), now.getMonth(), 1))
      const today = this.fmt(now)
      this.emit([first + ' 00:00:00', today + ' 23:59:59'])
      this.clearActive()
      this.dateNowMonthActive = true
    },

    setLastMonth() {
      const now = new Date()
      let year = now.getFullYear()
      let month = now.getMonth() // 0-based，getMonth()=0 表示1月
      if (month === 0) {
        month = 12
        year = year - 1
      }
      const pad = n => String(n).padStart(2, '0')
      const firstDay = `${year}-${pad(month)}-01`
      const lastDay = new Date(year, month, 0).getDate()
      const lastDayStr = `${year}-${pad(month)}-${pad(lastDay)}`
      this.emit([firstDay + ' 00:00:00', lastDayStr + ' 23:59:59'])
      this.clearActive()
      this.dateLastMonthActive = true
    },

    onPickerChange(val) {
      this.clearActive()
      this.$emit('input', val || [])
      this.$emit('change', val || [])
    }
  }
}
</script>

<style scoped>
.date-range-picker-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 10px;
  padding: 10px 14px;
  border: 1px solid #eaf1f8;
  border-radius: 10px;
  background: #fbfdff;
}

.date-range-label {
  color: #4d6985;
  font-size: 13px;
  font-weight: 700;
  margin-right: 2px;
}

.public_operatArea_timePicker {
  margin-left: 0;
}
</style>
